import { render, staticRenderFns } from "./fair-list-item.vue?vue&type=template&id=5d3cfef0&"
import script from "./fair-list-item.vue?vue&type=script&lang=js&"
export * from "./fair-list-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports